import { useEffect, useState } from "react";
import { AlertCircle } from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/alert-dialog";
import { Button } from "@/components/button";
import {
  setLogoutDialogHandler,
  keycloakService,
} from "@/services/keycloakService";

export const LogoutCountdownDialog = () => {
  const [open, setOpen] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Register the handler
    setLogoutDialogHandler((initialCountdown: number) => {
      setCountdown(initialCountdown);
      setOpen(true);
    });

    return () => {
      setLogoutDialogHandler(null);
    };
  }, []);

  useEffect(() => {
    if (!open || countdown <= 0) {
      if (countdown <= 0) {
        keycloakService.onAuthLogout();
      }
      return;
    }

    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [open, countdown]);

  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-destructive">
            <AlertCircle className="size-5" />
            Access Denied
          </AlertDialogTitle>
          <AlertDialogDescription className="pt-2">
            You do not have access to this application. You will be logged out
            in <span className="font-bold text-foreground">{countdown}</span>{" "}
            second{countdown !== 1 ? "s" : ""}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            onClick={() => keycloakService.onAuthLogout()}
            variant="destructive"
            className="w-full sm:w-auto"
          >
            Log out now
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
